import { useIntl } from "react-intl";

export const AdminInsightsImage = () => {
    const intl = useIntl();

    const messages = {
        altText: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AdminInsights.altText",
            defaultMessage: "Example of admin insights"
        })
    };

    return (
        <img
            src="https://wac-cdn.atlassian.com/misc-assets/webp-images/jsw-admin_insights_screenshot_with_sidebar.webp"
            alt={messages.altText}
            height={350}
            loading="lazy"
        />
    );
};

const AdminInsights = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AdminInsights.header",
            defaultMessage: "Admin insights"
        }),
        content: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AdminInsights.content",
            defaultMessage:
                "Get visibility and a better understanding of your product usage with data like level activity over time and security or access."
        }),
        caption: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AdminInsights.caption",
            defaultMessage:
                "Here’s what admin insights look like in Jira Service Management."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
            <AdminInsightsImage />
            <p>{messages.caption}</p>
        </>
    );
};

export default AdminInsights;
